module.exports = __webpack_public_path__ + "img/actueel.7b54b477.svg";